export const getBooking = (state) => state.bookingDetails.booking || {};
export const getOwnerProfile = (state) => state.bookingDetails.ownerProfile || {};
export const getRenterProfile = (state) => state.bookingDetails.renterProfile || {};
export const getBookingId = (state) => state.bookingDetails.booking.id;
export const getLoading = (state) => state.bookingDetails.loading;
export const getAdditionalDriver = (state) => state.bookingDetails.booking.additionalDriver || null;
export const getExtras = (state) => state.bookingDetails.booking.extras || [];
